// extracted by mini-css-extract-plugin
export default {"card":"styles_card__bbPRa","cardTitle":"styles_cardTitle__WJhJY","image":"styles_image__1Xekh","mainTitle":"styles_mainTitle__bOXpY"};